

export default  {
    NotStarted: "NotStarted",
    EnergyCommunitySelected: "EnergyCommunitySelected",
    PersonalDataCompleted: "PersonalDataCompleted",
    MeteringPointsSelected: "MeteringPointsSelected",
};